import ZField from './ZField.js';

export default window.ZForms.registerClass('field.date', class ZDateField extends ZField {
  parseRawValue(rawVal) {
    return new Date(rawVal);
  }
});

